import {Component, ViewEncapsulation} from '@angular/core';
import {AuthService} from './services/auth.service';
import {environment} from "../environments/environment";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
    constructor(public auth: AuthService, private router: Router) {
    }

    ngOnInit() {

        const publicRoutes = ['/verify', '/verify.html'];
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const currentRoute = event.urlAfterRedirects.split('?')[0];

                if (!this.auth.isLoggedIn() && !publicRoutes.includes(currentRoute)) {
                    this.auth.logout();
                }
            });

        // Periodic token check
        setInterval(() => {
            const currentRoute = this.router.url.split('?')[0];
            if (!this.auth.isLoggedIn() && !publicRoutes.includes(currentRoute)) {
                this.auth.logout();
            }
        }, environment.checkTokenInterval);
    }

}
